export default __webpack_public_path__ + "static/media/employees_8.c9520a4c.png";